module.exports = __webpack_public_path__ + "static/media/customer006.a7219308.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/img/customer006.png
// module id = 852
// module chunks = 0